import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { FormTemplateFieldConditionalRule } from 'mapistry-shared';
import React from 'react';
import { EMPTY_CONDITIONAL_RULE } from './consts';

export function AddConditionalRuleButton({
  addConditionalRule,
  focusCatcherRef,
}: {
  focusCatcherRef: React.RefObject<HTMLButtonElement>;
  addConditionalRule: (
    newRule: Partial<FormTemplateFieldConditionalRule>,
  ) => void;
}) {
  return (
    <Button
      color="primary"
      onClick={() => addConditionalRule(EMPTY_CONDITIONAL_RULE)}
      ref={focusCatcherRef}
    >
      <AddCircleOutlineIcon aria-hidden />
      Create new rule
    </Button>
  );
}
